var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('upper1MasterLower4Slave1Sun',{ref:"columnTables",attrs:{"zbParams":{
    opId: 3801,
    dataClass : 1,
    // searchHidden: true,   // 是否隐藏顶部搜索
    // topButtonArea: false,   // 是否隐藏顶部按钮
    tableHeight: 450, // 表格高度
    //isTopDelete: true,// 是否隐藏顶部的删除按钮 true隐藏
    //isTopAdd: true,// 是否隐藏顶部的新增按钮 true隐藏
    rowFilesClick: _vm.rowFilesClick,
  },"cbParams":{
    opId: 3801,
    dataClass : 2,
    searchHidden: true,   // 是否隐藏顶部搜索
    //topButtonArea: false,   // 是否隐藏顶部按钮
    tableHeight: 300, // 表格高度
    tzRecClick: _vm.tzRecClick,//跳转至收款表
  },"cb2Params":{
    opId: 3801,
    dataClass : 3,
    searchHidden: true,   // 是否隐藏顶部搜索
    //topButtonArea: false,   // 是否隐藏顶部按钮
    tableHeight: 300, // 表格高度
  },"cb3Params":{
    opId: 3801,
    dataClass : 4,
    searchHidden: true,   // 是否隐藏顶部搜索
    //topButtonArea: false,   // 是否隐藏顶部按钮
    tableHeight: 300, // 表格高度
  },"cb4Params":{
    opId: 3801,
    dataClass : 5,
    searchHidden: true,   // 是否隐藏顶部搜索
    topButtonArea: true,   // 是否隐藏顶部按钮
    tableHeight: 300, // 表格高度
    isTopDelete: true,// 是否隐藏顶部的删除按钮 true隐藏
    isTopAdd: true,// 是否隐藏顶部的新增按钮 true隐藏
  },"sunParams":{
    opId: 3801,
    dataClass : 6,
    searchHidden: true,   // 是否隐藏顶部搜索
    //topButtonArea: false,   // 是否隐藏顶部按钮
    tableHeight: 300, // 表格高度
  },"zcbGlgx":{
    parProp: 'CONID',
    chilProp: 'CONID',
    chilIDProp: 'CONDTLID',
    chil2Prop: 'CONID',
    chil3Prop: 'CONID',
    chil4Prop: 'CONID',
    chilsunProp: 'CONDTLID',
  },"splitUrl":{
      url:"contractMasterManySlave",
      finderId:3112,
      pinjieId:"CONDTLID",
      field:"CONDTLID",
      viewId:"B_INV_SELECT_TO_REC_V",
    },"tableName":{
    zbTableName: '合同总单',
    cbTableName: '合同细单',
    cb2TableName: '发票',
    cb3TableName: '供应商费用',
    cb4TableName: '利润',
    sunTableName: '收款',
  }},scopedSlots:_vm._u([{key:"menuRightSlave",fn:function(ref){
  var row = ref.row;
return undefined}}])}),_c('file-dialog',{attrs:{"visible":_vm.filedialog,"params":_vm.fileParams},on:{"update:visible":function($event){_vm.filedialog=$event},"isupload":_vm.isupload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }